$(document).ready(function() {
  let mobileDevice = false
  $(window).width() < 767 ? mobileDevice = true : mobileDevice = false

  function hideAndShowAnnouncementBarByDevice(mobileDevice) {
    if(mobileDevice) {
       $('.announcement-bar__message--mobile').show()
       $('.announcement-bar__message--desktop').hide();
    } else {
      $('.announcement-bar__message--mobile').hide()
      $('.announcement-bar__message--desktop').show();
    }
  }

  function showAnnouncementBar(mobileDevice, show = true) {
    if(show) {
      $('.announcement-bar').show();
      hideAndShowAnnouncementBarByDevice(mobileDevice)
    } else {
      $('.announcement-bar').hide();
    }
  }
  function showAndHideAnnouncementBarOnPageLoad(mobileDevice) {
    if(window.scrollY < 40) {
      showAnnouncementBar(mobileDevice)
    } else {
      showAnnouncementBar(mobileDevice, false)
    }
  }
  
  showAndHideAnnouncementBarOnPageLoad(mobileDevice)

  function navStickToTopOfViewport() {

    if(mobileDevice) {

      $('.site-header').css({
        'position': 'fixed',
        'top':'0',
      });
      
      $('.hiddenSearchInputOverlay').css({
        'position': 'fixed',
        'top':'54px', 
        'z-index': '10'
      });
   
    }else{

      $('.site-header').css({
        'position': 'fixed',
        'top':'0',
      });
      
      $('.hiddenSearchInputOverlay').css({
        'position': 'fixed',
        'top':'65px',
        'z-index': '10'
      });

    }


  }
  
  function navbarOriginalPosition() {
    $('.site-header').css({
      'position': 'absolute',
      'top': winWidth < 767 ? '45px' : '38px'
    });

    if(mobileDevice) {
      $('.hiddenSearchInputOverlay').css({
        'position': 'fixed',
        'top':'97px',
        'z-index': '10'
      }); 
    }else{
      $('.hiddenSearchInputOverlay').css({
        'position': 'fixed',
        'top':'113px',
        'z-index': '10'
      });
    }
  }

  function updateNavBarItemPadding(paddingTop, paddingBottom) {
    //$('.parent-item').css('padding', `${paddingTop} ${paddingBottom}`);
  }

  function minimizeNavBarHeight(verticalPadding) {
    let verticalPaddingWithoutPx = verticalPadding.replace(/\D/g,'');
    let reducedVerticalPadding = verticalPaddingWithoutPx * 0.75;
    return reducedVerticalPadding + 'px'
  }

  const navBarTop = $('.site-header').offset().top;
  
  let navBarItemVerticalPaddingSplit = $('.parent-item').css('padding').split(" ")
  let navBarItemVerticalPadding = navBarItemVerticalPaddingSplit[0];
  let navBarItemHorizontalPadding = navBarItemVerticalPaddingSplit[1]
  let reducedVerticalPaddingWithPx = minimizeNavBarHeight(navBarItemVerticalPadding)

  $(window).scroll(function() {
    let currentScroll = $(window).scrollTop();

    if(currentScroll >= navBarTop) {
      navStickToTopOfViewport();
      updateNavBarItemPadding(reducedVerticalPaddingWithPx, navBarItemHorizontalPadding);
      $(".gift-menu-on-navigation-bar").addClass("small-padding");
      $(".gift-menu-on-navigation-bar").removeClass("big-padding");
    } else {
      navbarOriginalPosition();
      updateNavBarItemPadding(navBarItemVerticalPadding, navBarItemHorizontalPadding);
      $(".gift-menu-on-navigation-bar").addClass("big-padding");
      $(".gift-menu-on-navigation-bar").removeClass("small-padding");
    }

    showAndHideAnnouncementBarOnPageLoad(mobileDevice)
  });

  function disableScroll() {
    var scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
    $('html').addClass('noscroll').css('top',-scrollTop);
  }

  function enableScroll() {
    var scrollTop = parseInt($('html').css('top'));
    $('html').removeClass('noscroll');
    $('html,body').scrollTop(-scrollTop); 
  }
  
  $('.close-popup').click(function(e) {
    e.preventDefault();
    $('.main-popup').fadeOut();
    localStorage.setItem("marketingPopup", 'closed');
  });
  $('.js-close-popup').on('click', function(e) {
    if (e.target !== this)
      return;
    $('.main-popup').fadeOut();
    localStorage.setItem("marketingPopup", 'closed');
  });
  
  $("#AccessibleNav .site-menu > ul").hover(
    function() {
      $(".menu-overlay").fadeIn("medium");
    }, function() {
      $(".menu-overlay").fadeOut("medium");
    }
  );

  if ( $(".cart__qty").length > 0) {
    $( ".cart__qty.cart__qty-wrapper").each(function() {
      $(this).find("input").wrap("<div class='qtty-wrap'></div>");
      $(this).find(".qtty-wrap").append( $("<a title='Decrease Quantity' href='javascript:void(0)' class='qtty-less'></a>") );
      $(this).find(".qtty-wrap").append( $("<a title='Increase Quantity' href='javascript:void(0)' class='qtty-add'></a>") );
    });

    $('.sidebar_cart_container input.btn.btn--small-wide.cart__submit.cart__submit-control').val('Proceed to Checkout');
  }

  if ( $("#CustomerLoginForm").length > 0) {
    $('.main-content').addClass("login-page");
    $("#LoginHeading").html("Customer Login");
  }

  if ( $(".maintenance-template").length > 0) {
    $('body').addClass("maintenance-template-body");
  }

  if ( $(".site-header__cart-count").length > 0) {
    $('.site-header__cart').addClass("cart-has-items");
  }

  if ( $(".lookbook-template").length > 0) {
    $('body').addClass("drawer-page-body");
  }

  if ( $("#RegisterForm").length > 0) {
    $('.main-content').addClass("login-page");
    $(".form-vertical h1").html("Sign Up");
    $("#RegisterForm").prepend( $(".form-vertical h1") );
    $(".form-vertical input[type=submit]").val("Create Account");
  }

  var single_p_slider = $('.single-product-slider').owlCarousel({
    loop: true,
    items: 1,
    nav: true,
    smartSpeed: 500,
    dots: false,
    video:true,
    navText: [
      '<img alt="arrow-right" src = "https://cdn.shopify.com/s/files/1/0597/8805/t/355/assets/home-featured-collection-left.svg?v=1626794351" />',
      '<img alt="arrow-left" src = "https://cdn.shopify.com/s/files/1/0597/8805/t/355/assets/home-featured-collection-right.svg?v=1626794337" />'
    ],
    responsive:{
      0:{
        dots: true
      },
      767:{
        dots: false
      }
    }
  });

  $('#media_4').on('click', function(){
    $("#media_4").addClass( "active-four" );
    $("#media_5").addClass( "active-no" );
  });

  $('#media_5, #media_1, #media_2, #media_3').on('click', function(){
    $("#media_4").removeClass( "active-four" );
    $("#media_5").removeClass( "active-no" );
  });

  $(document).on('click', '.product-thumbnails .item', function(){
    var target_id = $(this).data('id');
    single_p_slider.trigger('to.owl.carousel', [target_id]);
  });

  var ele_index = 0;
  var ele_item_index_old = 0;

  single_p_slider.on('changed.owl.carousel', function(event) {

    var item_height = $('.product-thumbnails-wrapper .item').height();
    var item_count      = event.item.count;
    var item_position = event.item.index;
    var item_index = 0;
    var ele_item_index = 0;

    if(item_count%2 == 0){
      item_index = item_count/2;
    }else{
      item_index = parseInt(item_count/2) + 1;
    }

    if(item_position < item_index){
      ele_item_index = item_count - 1;
    }else{
      ele_item_index = item_position - item_index;
    }

    $('.product-thumbnails .item').removeClass('active');
    $('.product-thumbnails [data-id=' + ele_item_index + ']').addClass('active');

    var element   = $('.product-thumbnails .active');
    ele_index++;

    ele_item_index_old = ele_item_index;

  });

  $(".backtop").click(function () {
    $("html, body").animate({scrollTop: 0}, 600);
  });

  $('.tab-heads li a').click(function(e){
    e.preventDefault();
    var t = $(this).attr('href');
  	console.log('tab was clicked')
    if(!$(this).hasClass('active')){
      $('.tab-heads li a').removeClass('active');           
      $(this).addClass('active');
      $('.service-tab-content').hide();
      let tabContent = t.replace('#', '.')
      console.log(tabContent);
      console.log($(this));
	  $(this).parentsUntil('.service-content').last().find(tabContent).fadeIn('medium');
    }
  });

  $('.faq h3, .faq .faqMobileTitleOpen').click(function(){
    if(!$(this).hasClass('opened')){
      $(this).addClass('opened');
      $(this).parent().find('.faq-content').slideDown();
    } else {
      $(this).removeClass('opened');
      $(this).parent().find('.faq-content').slideUp();
    }
  });
  
  function adjustMenuPaddingTop() {
   $('.mobile-menu.scrolled').css('padding-top', '55px');
  }
 
  $('.site-header__icons-hamburger').click(function(e) {
    e.preventDefault();
    
    if ($(this).hasClass('menu-opened')) {
      $('.mobile-menu').fadeOut('medium');
      $(this).removeClass('menu-opened');
      $('.site-header__icon-hamburger').css('display', 'flex');
      $('.site-header__icon-cross').hide();
      enableScroll();
    } else {
      adjustMenuPaddingTop();
      $('.mobile-menu').fadeIn('medium');
      $(this).addClass('menu-opened');
      $('.site-header__icon-hamburger').hide();
      $('.site-header__icon-cross').css('display', 'flex');
      disableScroll();
    }
  });

  function closeSubmenuItem(item) {
    item.next().slideUp('medium');
    item.removeClass('opened');
    item.find('svg').css('transform', 'rotate(0deg)');
    //item.parent().next().css('padding', '4% 0 4% 5%');
    //item.parent().css('padding', '4% 0 4% 5%') 
  }

  function openSubmenuItem(item) {
    item.next().slideDown('medium');
    item.addClass('opened');
    item.find('svg').css('transform', 'rotate(180deg)');
    //item.parent().css('padding', '4% 0 0 5%')
    //item.parent().next().css('padding', '0 0 4% 5%');
  }

  function closeAllMobileSubmenuItems(dropdownTitle) {
    dropdownTitle.find('li').each(function(i, li) {
      let item = $(li).find('a.opened');
      console.log(item);
      closeSubmenuItem(item);
    });
  }

  
  $('.mobile-main-nav__title').click(function(e) {
    e.preventDefault();

    $(this).next().toggle('medium', function() {
      if($(this).is(":visible")) {
        $(this).parent().find('.mobile-main-nav__title').find('svg').css('transform', 'rotate(180deg)'); 
        $(this).parent().find('.mobile-main-nav__title').addClass("closedSVG"); 
      } else {
        closeAllMobileSubmenuItems($(this));
        $(this).parent().find('.mobile-main-nav__title').find('svg').css('transform', 'rotate(0deg)');
        $(this).parent().find('.mobile-main-nav__title').removeClass("closedSVG"); 
      }
    });
  });

  $('#ourStoresLinkMobile').click(function(e) {
    window.location.href =  "https://lucafaloni.com" + Shopify.routes.root + 'pages/our-stores';
  });

  $('#LoyaltyLinkMobile').click(function(e) {
    window.location.href = "https://lucafaloni.com" + Shopify.routes.root + 'pages/loyalty-programme';
  });
 

  $('.smenu > a').click(function(e) {
    e.preventDefault();
    if ($(this).hasClass('opened')) {
      console.log($(this))
      closeSubmenuItem($(this));
    } else {
      openSubmenuItem($(this));
    }
  });

  var winWidth = $(window).width();
  if (winWidth < 768) {
    $('footer.site-footer p.h4').click(function(e) {
      e.preventDefault();

      if ($(this).hasClass('opened')) {
        $(this).parent().find('.site-footer__linklist').slideUp('medium');
        $(this).removeClass('opened');
      } else {
        $(this).parent().find('.site-footer__linklist').slideDown('medium');
        $(this).addClass('opened');
      }
    });
    if ( $(".main-slider-content").length > 0) {
      $(".main-slider-content .btn").insertAfter( $(".main-slider-content .medium-up--one-half p") );
    }
  }
  
  if ( $(".blog-grid").length > 0) {
    var winWidth = $(window).width();
    if (winWidth < 768) {
      $(".blog-grid").each(function() {
        $(this).find(".grid-image").insertBefore( $(this).find(".grid-content") );
      });
    }
  }

  if ( $(".template-index").length > 0) {
    $(".home-video-frame iframe").wrap("<div class='videoWrapper'></div>");
  }

  $(".parent-trigger").hover(function () {
    $(this).addClass("hovered");
    $(".hiddenSearchInputOverlay").hide();
    $(this).find(".mega-nav").show();
    
  },function () {
    $(this).find(".mega-nav").hide();
    $(this).removeClass("hovered");
  });

  $(".book-menu .menu-col a").hover(function () {
    $(this).find(".visible").hide();
    $(this).find(".hidden").show();
  },function () {
    $(this).find(".visible").show();
    $(this).find(".hidden").hide();
  });

  //   $('.site-header__search-toggle').click(function(e) {
  //     e.preventDefault();

  //     if ($('body').hasClass('search-opened')) {
  //       $('body').removeClass('search-opened');
  //     } else {
  //       $('body').addClass('search-opened');
  //     }
  //   });

  if ( $(".product-form-product-template .single-option-selector").length == 0) {
    $('.product-form__variants option:eq(1)').attr('selected', 'selected');
  }

  $('.pre-order-btn').click(function(e){
    e.preventDefault();
    if ( $("#SingleOptionSelector-0").length > 0) {
      var psize = $("#SingleOptionSelector-0 :selected").val();
      if (psize == "") {
        alert("Please select the size.");
      } else if ( $("#SingleOptionSelector-1").length > 0) {
        var pfit = $("#SingleOptionSelector-1 :selected").val();
        if (pfit == "") {
          alert("Please select the fit.");
        } else {
          $(this).parents('.product-single').find('.product-form').submit();
        }
      } else {
        $(this).parents('.product-single').find('.product-form').submit();
      }
    } else {
      $(this).parents('.product-single').find('.product-form').submit();
    }
  });
  
  $('.close-popup').click(function(e) {
    e.preventDefault();
    $('.main-popup').fadeOut();
    localStorage.setItem("marketingPopup", 'closed');
  });
  $('.js-close-popup').on('click', function(e) {
    if (e.target !== this)
      return;
    $('.main-popup').fadeOut();
    localStorage.setItem("marketingPopup", 'closed');
  });

  if ( $(".lookbook-template").length > 0) {
    $(".prefooter").hide();
    $("#shopify-section-footer").hide();
  }

  $('.lbookanim .lbookright').hover(function() {
    jQuery(this).find('.product-card__image-wrapper').slideDown();
  });
});

$(window).load(function() {
  $(".sidebar_cart_inner input[name=checkout]").val("Checkout");

  if(window.location.href.indexOf("#") > -1) {
    var cUrl = $(location).attr('href');
    var target = cUrl.substr(cUrl.indexOf("#") + 1)
    if(!$("body.template-product").length > 0) {
      $("." + target).trigger("click");

    }

    //     $('html, body').animate({
    //       scrollTop: $("body").offset().top
    //     }, 0);
  }

  $('.site-footer__linklist a').click(function(){
    var h_url = $(this).attr('href');
    if(h_url.indexOf("#") > -1) {
      var h_target = h_url.substr(cUrl.indexOf("#") + 1);
      $("." + h_target).trigger("click");

      $('html, body').animate({
        scrollTop: $("body").offset().top
      }, 30);
    }else{

    }
  });

  if ( $(".collection__discover_slider").length > 0) {
    $(".collection__discover_slider .owl-item").each(function() {
      var dataid = $(this).find(".item").attr("data-id");
      var itemlink = $(this).find("a").attr("href");

      if (!$(this).hasClass("cloned")) {
        $("#bps" + dataid).find("img").wrap("<a href='" + itemlink + "'></a>");
      }

      var winWidth = $(window).width();
      if (winWidth < 768) {
        $(this).find(".grid-view-item__image").wrap("<a href='" + itemlink + "'></a>");
        var imageUrl = $("#bps" + dataid).find("img").attr("src");
        $(this).find(".grid-view-item__image").attr('src',imageUrl);
      }
    });
  }
});

  /*
$('form.newsletter-form-popup').submit(function(e) {
  e.preventDefault();

  var $form = $(this);
  var $email_address = $(this).find('#ContactFooter-email').val();
  var fromFooterNewsletterSignup = false
  
  if($form.parent().hasClass('site-footer__newsletter')) {
   fromFooterNewsletterSignup = true
  } 
  
  if($email_address){
    register($form, fromFooterNewsletterSignup);
  }else{
    alert("Insert Email Address"); 
  }
});
*/ 

function ValidateEmail(mail){
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
  {
    return (true);
  }
  alert("You have entered an invalid email address!");
  return (false);
}

function showResponseFromMailChimp(status, message, $form, fromFooterNewsletterSignup) {  
  let mailchimpResponseContainer = fromFooterNewsletterSignup ? $form.parent().find('.footer-signup-description') : $form.find('.main-popup-description')
  
  console.log(mailchimpResponseContainer, status, message)
  if(status == 400 && message == 'Member Exists') {
   mailchimpResponseContainer.text("This email address is already registered to the Luca Faloni newsletter.\n Thank you for being a loyal subscriber.");
  } else {
   mailchimpResponseContainer.text(message);
  }
  
  $form.find('.ui').html('<a href="#" class="btn">Continue Shopping</a>');
  $('.discount-newsletter__close-texts').hide();
}

function register($form, fromFooterNewsletterSignup) {  
  $form.find('#mc-embedded-subscribe').val('JOIN');
  var $email_address = $form.find('#ContactFooter-email').val();
  var $tag = $form.find('.newsletter-signup-mailchimp__tag-holder').data('mailchimp-tag');
  var $country = localStorage.getItem('lf_country_code');

  var $f_data = {
    'email_address': $email_address,
    'country': $country
  };
  
  var $handle = 'https://lucafaloni-server-fyjik.ondigitalocean.app/lucafaloni_apis/subscribe_to_uk_klaviyo_list';

  $.ajax({
    type: 'POST',
    url: $handle,
    data: $f_data,
    crossDomain: true,
    cache: false,
    error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
    success: function (data) {   
      console.log(data);
     showResponseFromMailChimp(data.status, data.title, $form, fromFooterNewsletterSignup)
    }
  });
}


$('form.newsletter-form-popup, .newsletter-signup-here').on('click', function(e){
  e.preventDefault();
  var winWidth = $(window).width();

  if(winWidth < 767){
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'Tap4AQ']);
  }else{
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'QRyfbQ']);
  }
});

function scrollEnable(){
  var scrollTop = parseInt($('html').css('top'));
  $('html').removeClass('noscroll');
  $('html,body').scrollTop(-scrollTop); 
}

$('.nav-newsletter-trigger').on('click', function(e){
  e.preventDefault();

  var winWidth = $(window).width();

  if(winWidth < 767){
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'Tap4AQ']);
    scrollEnable();
    $(".mobile-menu").hide();
    $('.site-header__icon-hamburger').css('display', 'flex');
    $('.site-header__icon-cross').hide();
    if($('.site-header__icons-hamburger').hasClass('menu-opened')){
      $('.site-header__icons-hamburger').removeClass('menu-opened');
    }
  }else{
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'QRyfbQ']);
  }

});

$('body').on('click', '.main-popup .ui a.btn', function(e){
  e.preventDefault();
  $('.close-popup').trigger('click');
});

//plpbanner clickable
$(window).load(function(){
  if($('.template-collection .plp-banner')){
  	var plp_link = $('.template-collection .plp-banner').find('a').attr('href');
    if(plp_link != ''){
    	$('.template-collection .plp-banner').wrap('<a href="' + plp_link + '"></a>');
    }
  }
});

$(window).load(function(){
  if($('.template-collection .pcp-video')){
  	var plp_link = $('.template-collection .pcp-video').find('a').attr('href');
    if(plp_link != ''){
      $('.template-collection .pcp-video > div:first-child').wrap('<a href="' + plp_link + '"></a>');
    }
  }
});

/*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/

Shopify.updateOptionsInSelector = function(selectorIndex, parent) {

  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $(parent + ' .single-option-selector:eq(0)');
      break;
    case 1:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      var selector = $(parent + ' .single-option-selector:eq(1)');
      break;
    case 2:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
      var selector = $(parent + ' .single-option-selector:eq(2)');
  }

  var availableOptions = Shopify.optionsMap[key];
  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
    }
    else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled','disabled');
    }
  });

};

Shopify.linkOptionSelectors = function(product, parent) {
    // Building our mapping object.
    Shopify.optionsMap = {};
    for (var i=0; i<product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.available) {
        // Gathering values for the 1st drop-down.
        Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
        Shopify.optionsMap['root'].push(variant.option1);
        Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
        // Gathering values for the 2nd drop-down.
        if (product.options.length > 1) {
          var key = variant.option1;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option2);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option3);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
      }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    // When there is an update in the first dropdown.
    $(parent + " .single-option-selector:eq(0)").change(function() {
      Shopify.updateOptionsInSelector(1, parent);
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
    // When there is an update in the second dropdown.
    $(parent + " .single-option-selector:eq(1)").change(function() {
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
};

selectCallback = function(variant, selector) {
  if(variant){
    var productData = $('.template-product .product_form_options').data('product');
    var produc_slider = $('.single-variant-slider');
    produc_slider.removeClass('owl-carousel owl-loaded owl-drag');

    if(productData){
      var product_images = productData.media;
      if( product_images.length > 0){
        produc_slider.empty();
        product_images.forEach(function(item, i){
          if(item.alt == variant.option2){
              produc_slider.append('<div class="enlarge_pane_contain" id="media_' + i + '" data-color="' + item.alt + '"><div class="enlarge_pane"><div class="enlarge" id="enlarge__content"><div class="enlarge_contain"><img data-image-id="'+item.id+'" data-sizes="auto" class="lazyload lazyload-fade" data-src="' + item.src + '" alt="' + item.alt + '" src="' + item.src + '"><noscript><img id="'+item.id+'" class="product__image lazyload lazyload-fade" data-src="'+item.src+'" data-sizes="auto" data-zoom-src="'+item.src+'" alt="'+item.alt+'" /></noscript></div></div></div>')
          }
        });
      } else {

      }
    }

    produc_slider.addClass('owl-carousel');

    produc_slider.trigger('destroy.owl.carousel');

    var p_v_owl = produc_slider.owlCarousel({
      loop: true,
      items: 1,
      nav: true,
      smartSpeed: 1000,
      navText: [
        '<i class="fa fa-angle-left" aria-hidden="true"></i>',
        '<i class="fa fa-angle-right" aria-hidden="true"></i>'
      ]
    });
  }
  
};

$(".js-product_container .product_form_options").each(function() {
  new Shopify.OptionSelectors($(this).data("select-id"), { product: $(this).data("product"), onVariantSelected: selectCallback, enableHistoryState: $(this).data("enable-state") });
});

if ($('.js-product_container').length){
  var $productForms = $('.js-product_container').find('.product_form_options');
  $productForms.addClass('is-visible');

  //Loop through each product and set the initial option value state

  $productForms.each(function(){
    var JSONData = $(this).data('product');
    var productID = $(this).data('product-id');
    var productSection = '.product-' + productID + ' .product_form_options';
    var swatchOptions = $(this).find('.swatch_options .swatch');
    if (swatchOptions.length > 1){
      Shopify.linkOptionSelectors(JSONData, productSection);
    }
  });
}

$('body').on('change', '.swatch :radio, .swatch select', function() {
  
  var optionIndex = $(this).closest('.swatch').attr('data-option-index');
  var optionValue = $(this).val();
  var parentForm = $(this).closest('form');

  $(this)
  .closest('form')
  .find('.single-option-selector')
  .eq(optionIndex)
  .val(optionValue)
  .trigger('change');
  
});

// Video Script
var iframe = $('iframe.video-iframe');
if(iframe.length > 0){
  var player = new Vimeo.Player(iframe);

  player.on('play', function() {
    console.log('played the video!');
  });

  player.setVolume(0).then(function(volume) {
    // volume was set
  }).catch(function(error) {
    switch (error.name) {
      case 'RangeError':
        // the volume was less than 0 or greater than 1
        break;

      default:
        // some other error occurred
        break;
    }
  });

  $(document).ready(function(){
    $('.video-volumn-control').on('click', function(){
      $(this).toggleClass('active');
      if($(this).hasClass('active')){
        player.setVolume(0.5);
      }else{
        player.setVolume(0);
      }
    })
  });
}

$(window).load(function(){
  var home_ratio = 0.444;
  var collection_ratio = 0.445;
  var home_video_width = $('.home-video-frame-new').width();
  if($('.home-video-frame-new iframe').length > 0){
    if($('body').hasClass('template-collection')){
    	$('.home-video-frame-new iframe').height(collection_ratio*home_video_width + 'px');
    }else{
      console.log("Howdy");
    	$('.home-video-frame-new iframe').height(home_ratio*home_video_width + 'px');
    }
    $(window).resize(function(){
      var home_video_width = $('.home-video-frame-new').width();
      if($('body').hasClass('template-collection')){
        $('.home-video-frame-new iframe').height(collection_ratio*home_video_width + 'px');
      }else{
        $('.home-video-frame-new iframe').height(home_ratio*home_video_width + 'px');
      }
    });
  }
  
});